import axios from "axios";
import { customerOrigin } from "../enums/enum";

const ARK_API_URL = process.env.ARK_API_URL;

export const sendNewProcessByEmail = async (emailData) => {
  try {
    const resp = await axios.post(`${ARK_API_URL}/customers/process`, {
        ...emailData,
        origin: customerOrigin.newprocess
    });
    return true;
  } catch (error) {
    console.error("Error sending process email:", error);
  }
};